import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

const FittingDraftContext = createContext(null);

/**
 * Черновик примерки живёт на уровне /main, пока открыт main — не теряется
 * при переходе /main/fitting ↔ /main/profile/liked.
 */
export function FittingDraftProvider({ children }) {
  const [selUpper, setSelUpper] = useState(null);
  const [selLower, setSelLower] = useState(null);
  const [selShoe, setSelShoe] = useState(null);
  const [userFile, setUserFile] = useState(null);
  const [userPreviewUrl, setUserPreviewUrl] = useState(null);
  const previewBlobRef = useRef(null);
  const [resultUrl, setResultUrl] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const setUserPhoto = useCallback((file) => {
    if (previewBlobRef.current) {
      URL.revokeObjectURL(previewBlobRef.current);
      previewBlobRef.current = null;
    }
    if (!file) {
      setUserFile(null);
      setUserPreviewUrl(null);
      return;
    }
    const url = URL.createObjectURL(file);
    previewBlobRef.current = url;
    setUserFile(file);
    setUserPreviewUrl(url);
  }, []);

  useEffect(
    () => () => {
      if (previewBlobRef.current) {
        URL.revokeObjectURL(previewBlobRef.current);
      }
    },
    [],
  );

  const value = useMemo(
    () => ({
      selUpper,
      setSelUpper,
      selLower,
      setSelLower,
      selShoe,
      setSelShoe,
      userFile,
      userPreviewUrl,
      setUserPhoto,
      resultUrl,
      setResultUrl,
      error,
      setError,
      loading,
      setLoading,
    }),
    [
      selUpper,
      selLower,
      selShoe,
      userFile,
      userPreviewUrl,
      setUserPhoto,
      resultUrl,
      error,
      loading,
    ],
  );

  return <FittingDraftContext.Provider value={value}>{children}</FittingDraftContext.Provider>;
}

export function useFittingDraft() {
  const ctx = useContext(FittingDraftContext);
  if (!ctx) {
    throw new Error('useFittingDraft must be used under FittingDraftProvider');
  }
  return ctx;
}
